import active_sekac from './active/sekac.svg';
import active_demon_administrativy from './active/demon_administrativy.svg';
import active_dotahovac from './active/dotahovac.svg';
import active_dotahovac_2 from './active/dotahovac_2.svg';
import active_elektrizujici_vykon from './active/elektrizujici_vykon.svg';
import active_jizda_pod_plynem from './active/jizda_pod_plynem.svg';
import active_mas_jiskru from './active/mas_jiskru.svg';
import active_mas_stavu from './active/mas_stavu.svg';
import active_matador from './active/matador.svg';
import active_nakrmeny_mozek from './active/nakrmeny_mozek.svg';
import active_nezdolna_energie from './active/nezdolna_energie.svg';
import active_pali_ti_to from './active/pali_ti_to.svg';
import active_s_plynem_na_podlaze from './active/s_plynem_na_podlaze.svg';
import active_sprinter from './active/sprinter.svg';
import active_super_pruvodce from './active/super_pruvodce.svg';
import active_vseznalek from './active/vseznalek.svg';
import active_vytrvalec from './active/vytrvalec.svg';
import active_zapaleny_ctenar from './active/zapaleny_ctenar.svg';
import active_zkuseny_pruvodce from './active/zkuseny_pruvodce.svg';
import active_zrout_informaci from './active/zrout_informaci.svg';
import gray_sekac from './gray/sekac.svg';
import gray_demon_administrativy from './gray/demon_administrativy.svg';
import gray_dotahovac from './gray/dotahovac.svg';
import gray_dotahovac_2 from './gray/dotahovac_2.svg';
import gray_elektrizujici_vykon from './gray/elektrizujici_vykon.svg';
import gray_jizda_pod_plynem from './gray/jizda_pod_plynem.svg';
import gray_mas_jiskru from './gray/mas_jiskru.svg';
import gray_mas_stavu from './gray/mas_stavu.svg';
import gray_matador from './gray/matador.svg';
import gray_nakrmeny_mozek from './gray/nakrmeny_mozek.svg';
import gray_nezdolna_energie from './gray/nezdolna_energie.svg';
import gray_pali_ti_to from './gray/pali_ti_to.svg';
import gray_s_plynem_na_podlaze from './gray/s_plynem_na_podlaze.svg';
import gray_sprinter from './gray/sprinter.svg';
import gray_super_pruvodce from './gray/super_pruvodce.svg';
import gray_vseznalek from './gray/vseznalek.svg';
import gray_vytrvalec from './gray/vytrvalec.svg';
import gray_zapaleny_ctenar from './gray/zapaleny_ctenar.svg';
import gray_zkuseny_pruvodce from './gray/zkuseny_pruvodce.svg';
import gray_zrout_informaci from './gray/zrout_informaci.svg';

const images = {
    active: {
        sekac: active_sekac,
        demon_administrativy: active_demon_administrativy,
        jizda_pod_plynem: active_jizda_pod_plynem,
        dotahovac: active_dotahovac,
        dotahovac_2: active_dotahovac_2,
        elektrizujici_vykon: active_elektrizujici_vykon,
        mas_jiskru: active_mas_jiskru,
        mas_stavu: active_mas_stavu,
        matador: active_matador,
        nakrmeny_mozek: active_nakrmeny_mozek,
        nezdolna_energie: active_nezdolna_energie,
        pali_ti_to: active_pali_ti_to,
        s_plynem_na_podlaze: active_s_plynem_na_podlaze,
        sprinter: active_sprinter,
        super_pruvodce: active_super_pruvodce,
        vseznalek: active_vseznalek,
        vytrvalec: active_vytrvalec,
        zapaleny_ctenar: active_zapaleny_ctenar,
        zkuseny_pruvodce: active_zkuseny_pruvodce,
        zrout_informaci: active_zrout_informaci,
    },
    gray: {
        sekac: gray_sekac,
        demon_administrativy: gray_demon_administrativy,
        jizda_pod_plynem: gray_jizda_pod_plynem,
        dotahovac: gray_dotahovac,
        dotahovac_2: gray_dotahovac_2,
        elektrizujici_vykon: gray_elektrizujici_vykon,
        mas_jiskru: gray_mas_jiskru,
        mas_stavu: gray_mas_stavu,
        matador: gray_matador,
        nakrmeny_mozek: gray_nakrmeny_mozek,
        nezdolna_energie: gray_nezdolna_energie,
        pali_ti_to: gray_pali_ti_to,
        s_plynem_na_podlaze: gray_s_plynem_na_podlaze,
        sprinter: gray_sprinter,
        super_pruvodce: gray_super_pruvodce,
        vseznalek: gray_vseznalek,
        vytrvalec: gray_vytrvalec,
        zapaleny_ctenar: gray_zapaleny_ctenar,
        zkuseny_pruvodce: gray_zkuseny_pruvodce,
        zrout_informaci: gray_zrout_informaci,
    }
};

export default images;
